import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "TimeOffList",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getTimeOffList, getTimeOffListError, getTimeOffListSuccess } =
  slice.actions;

reducerRegistry.register("timeOffList", reducer);
